import { render, staticRenderFns } from "./EmpBasic.vue?vue&type=template&id=77c4ff94&scoped=true&"
import script from "./EmpBasic.vue?vue&type=script&lang=js&"
export * from "./EmpBasic.vue?vue&type=script&lang=js&"
import style0 from "./EmpBasic.vue?vue&type=style&index=0&id=77c4ff94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c4ff94",
  null
  
)

export default component.exports